import { render, staticRenderFns } from "./VATDeclaration.vue?vue&type=template&id=7741ec26&scoped=true&"
import script from "./VATDeclaration.vue?vue&type=script&lang=js&"
export * from "./VATDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./VATDeclaration.vue?vue&type=style&index=0&id=7741ec26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7741ec26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VRow,VSelect})
